import axiosInstance from '../../utils/axiosInstanse';
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Spiner from '../Spiner/Spiner';
import host from "../../host";
import Card from "./Card";
import './pass_activate.css';

function Archive() {
    const [notes, setNotes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(undefined);

    useEffect(() => {
        axiosInstance.get(`${host}api/pass_activate/`)
            .then(response => {
                setNotes(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.response?.status === 403) {
                    setIsError(true);
                }
                setIsLoading(false);
            });
    }, []);

    return (
        <div>
            {isLoading ? (
                <Spiner />
            ) : (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.12 }}
                >
                    {isError ? (
                        <div className="pa-access-denied">У вас нет прав для доступа к данному разделу</div>
                    ) : notes.length > 0 ? (
                        notes.map((note) => (
                            <Card key={note.id} note={note} />
                        ))
                    ) : (
                        <div className="pa-empty">У вас нет заявок</div>
                    )}
                    <div style={{ marginBottom: 70 }}></div>
                </motion.div>
            )}
        </div>
    );
}

export default Archive;